<app-header [darkMode]="darkMode$ | async" [scrollArea]="scrollArea"></app-header>

<ion-content #scrollArea scrollEvents="true" fullscreen="true">
  <div class="main-wrapper">
    <div class="main-container">
      <article *ngIf="data$ | async as data">
        <div class="article-header">
          <h1>{{ data.title }}<small *ngIf="data.subtitle">{{ data.subtitle }}</small></h1>

          <div class="intro" *ngIf="data.intro" [innerHTML]="data.intro"></div>

          <div class="summary">
            <div class="infos" *ngIf="data.infos?.length">
              <div class="info-item" *ngFor="let item of data.infos">
                <strong class="title">{{ item.title }}</strong>
                <div class="item-content" [innerHTML]="item.text"></div>
              </div>
            </div>
            <div class="stack" *ngIf="data.stack?.length">
              <strong class="title">{{ 'summary.stack' | translate }}</strong>
              <ul>
                <li *ngFor="let item of data.stack">{{ item.title }}</li>
              </ul>
            </div>
            <div class="links" *ngIf="data.link || data.repo_link || data.wiki_link || data.support_link">
              <strong class="title">{{ 'summary.links' | translate }}</strong>
              <ion-button *ngIf="data.link" color="secondary" [href]="data.link" target="_blank" rel="nofollow">
                <ion-icon slot="start" name="exit-outline"></ion-icon>
                <span class="align-left">
                  {{ 'summary.btn-link' | translate }}
                </span>
              </ion-button>
              <ion-button *ngIf="data.repo_link" color="dark" [href]="data.repo_link" target="_blank" rel="nofollow">
                <ion-icon slot="start" name="logo-github"></ion-icon>
                <span class="align-left">
                  {{ 'summary.btn-repo' | translate }}
                </span>
              </ion-button>
              <ion-button *ngIf="data.wiki_link" color="dark" [href]="data.wiki_link" target="_blank" rel="nofollow">
                <ion-icon slot="start" name="book-outline"></ion-icon>
                <span class="align-left">
                  {{ 'summary.btn-wiki' | translate }}
                </span>
              </ion-button>
              <ion-button *ngIf="data.support_link" color="dark" [href]="data.support_link" target="_blank"
                rel="nofollow">
                <ion-icon slot="start" name="help-buoy-outline"></ion-icon>
                <span class="align-left">
                  {{ 'summary.btn-support' | translate }}
                </span>
              </ion-button>
            </div>
          </div>
        </div>

        <div class="contents-wrapper">
          <app-content-blocks *ngIf="data.contents" [contents]="data.contents" [locale]="currentLanguage$ | async"
            [darkMode]="darkMode$ | async">
          </app-content-blocks>
        </div>

        <app-section *ngFor="let section of data.sections; trackBy:sectionById;" [data]="section"
          [index]="section.title_index" [darkMode]="darkMode$ | async" [locale]="currentLanguage$ | async">
        </app-section>
      </article>

      <app-not-found *ngIf="notFound$ | async"></app-not-found>
    </div>

    <app-footer id="hello"></app-footer>
  </div>

  <app-loader [loading$]="loading$"></app-loader>
</ion-content>